// Contacts feature — query-key gyár + a lista-szűrő típusa. A tényleges hívásokat a route a tipizált
// ts-rest kliensen (`api.contacts.*`) intézi; a kulcsok itt élnek (cache-invalidálás egységesen).
// A `@atlas/contracts` a szerződés forrás-igazsága — itt csak kulcs/segéd-logika van.

/** A lista-lekérdezés szűrői (a query-kulcs része — szűrő-váltás új cache-bejegyzést nyit).
 *  A rendezés-KULCS fixen a név (magyar collation, szerver-oldal) — csak az irány (`order`) váltható. */
export interface ContactListFilters {
  q: string;
  order: 'asc' | 'desc';
}

/** Query-kulcs gyár — a lista-cache egységes címzése. */
export const contactKeys = {
  all: ['contacts'] as const,
  lists: () => ['contacts', 'list'] as const,
  list: (filters: ContactListFilters) => ['contacts', 'list', filters] as const,
};
